import { render, staticRenderFns } from "./ProjectResourceCostsPage.vue?vue&type=template&id=0d4d8bf9&scoped=true"
import script from "./ProjectResourceCostsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectResourceCostsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectResourceCostsPage.vue?vue&type=style&index=0&id=0d4d8bf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d8bf9",
  null
  
)

export default component.exports